module.exports = __webpack_public_path__ + "img/yggdrasil.dc7b90c5.svg";